// ============================================
// 2026-10-13（用户反馈）：图层列表左键拖拽排序 —— 纯几何函数（可单测）
// ============================================

/** 根据鼠标 Y 与各行矩形（按视觉从上到下）计算插入位置：0..n（n=追加到末尾） */
export function dropIndexFor(y: number, rects: { top: number; bottom: number }[]): number {
  for (let i = 0; i < rects.length; i++) {
    const mid = (rects[i].top + rects[i].bottom) / 2;
    if (y < mid) return i;
  }
  return rects.length;
}

/** 拖拽落位：把 fromId 从 list 中取出并插到 overIndex（考虑移除后的偏移），返回新 id 顺序 */
export function reorderByDrop(list: string[], fromId: string, overIndex: number): string[] {
  const fromIdx = list.indexOf(fromId);
  if (fromIdx < 0) return list;
  const next = list.filter((id) => id !== fromId);
  let insert = overIndex;
  if (fromIdx < overIndex) insert -= 1;
  insert = Math.max(0, Math.min(next.length, insert));
  next.splice(insert, 0, fromId);
  return next;
}
